import React, { createContext, useContext, useState } from 'react';
import { Subscriber } from '../entities/Subscriber';

interface UserContextData {
  user?: Subscriber;
  setUser: React.Dispatch<React.SetStateAction<Subscriber>>;
}
const UserContext = createContext<UserContextData>({} as UserContextData);

export const UserProvider: React.FC = ({ children }) => {
  const [user, setUser] = useState<Subscriber>({} as Subscriber);

  // TODO try/catchs
  return (
    <UserContext.Provider
      value={{
        user,
        setUser,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUser = (): UserContextData => {
  const context = useContext(UserContext);

  if (!context) {
    throw new Error('useUser must be used within a UserProvider');
  }

  return context;
};
